import { render, staticRenderFns } from "./UiSpinnerLoading.vue?vue&type=template&id=5cca0cc5&scoped=true&"
import script from "./UiSpinnerLoading.vue?vue&type=script&lang=js&"
export * from "./UiSpinnerLoading.vue?vue&type=script&lang=js&"
import style0 from "./UiSpinnerLoading.vue?vue&type=style&index=0&id=5cca0cc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca0cc5",
  null
  
)

export default component.exports